import eControllerTypes from './eControllerTypes';

export default {
  EPCT_DROPDOWN: `${eControllerTypes.ERCCT_START_POPUP}__dropdown`,
}
